// Stub for @fortawesome/pro-duotone-svg-icons
// Provides empty fad export to prevent errors
export const fad = {
  prefix: 'fad',
  iconName: 'stub',
  icon: [0, 0, [], '', '']
};
